const cateMap = {
  'IBD-投行': ['承揽-承做', '意向平台'],
  'FOF-FOF': ['公开业绩', '投资标的', '投资年限'],
  'FII-固收投资': ['公开业绩', '投资年限'],
  'QDII-海外投资（二级市场）': ['投资年限'],
  'EQ-股票投资': ['投资年限'],
  'QUANT-量化投资': ['公开业绩', '投资年限'],
  'HH-猎头': ['擅长职能', '团队业绩', '开票业绩', '擅长职位', '客户资源'],
  '医疗-设备销售': ['医疗科室'],
  '医疗-器械耗材销售': ['医疗科室'],
  '医疗-IVD销售': ['医疗科室'],
  '医疗-渠道管理': ['医疗科室'],
  '医疗-研发产品经理': ['医疗科室'],
  '医疗-测试': ['医疗科室'],
  '医疗-研发工艺': ['医疗科室'],
  '医疗-研发项目管理': ['医疗科室'],
  '医疗-研发工程师': ['医疗科室'],
  '医疗-研发质量': ['医疗科室'],
  '医疗-器械注册申报': ['医疗科室'],
  '医疗-中央市场': ['医疗科室'],
  '医疗-上游产品（市场）': ['医疗科室'],
  '医疗-区域市场': ['医疗科室'],
  '医疗-临床研究': ['医疗科室'],
  '医疗-临床项目管理': ['医疗科室'],
  '医疗-器械采购': ['医疗科室'],
  '医疗-售后': ['医疗科室'],
  '医疗-市场准入': ['医疗科室'],
  '医疗-招投标': ['医疗科室'],
  '医疗-政府事务': ['医疗科室'],
  '医疗-NPI项目管理': ['医疗科室'],
  'RI-研究': ['转换诉求'],
  'FI-债券开发执行': ['承揽-承做'],
  公募REITs: ['REITs任职情况'],
  硬件开发: ['是否量产', '是否流片'],
  数字芯片设计: ['是否量产', '是否流片'],
  晶圆制造: ['是否量产', '是否流片'],
  封装工程师: ['是否量产', '是否流片'],
  '电子设计自动化(EDA)': ['是否量产', '是否流片'],
  芯片项目管理: ['是否量产', '是否流片'],
  模拟芯片设计: ['是否量产', '是否流片'],
  其他芯片设计: ['是否量产', '是否流片'],
  软件研发: ['是否量产', '是否流片'],
  '芯片-产品经理': ['是否量产', '是否流片'],
  芯片销售: ['是否量产', '是否流片'],
  // 'AE&FAE': ['是否量产', '是否流片'],
  芯片设计相关软件开发: ['是否量产', '是否流片'],
  芯片设计其他技术类: ['是否量产', '是否流片'],
  其他半导体设计: ['是否量产', '是否流片'],
  'PEVC-股权投资': ['平台性质', '投资阶段', '特殊能力'],
  '芯片-数字芯片': ['是否量产', '是否流片'],
  '芯片-晶圆制造': ['是否量产', '是否流片'],
  '芯片-封装': ['是否量产', '是否流片'],
  '芯片-EDA': ['是否量产', '是否流片'],
  '芯片-项目管理': ['是否量产', '是否流片'],
  '芯片-模拟芯片': ['是否量产', '是否流片'],
  '芯片-其他芯片设计': ['是否量产', '是否流片'],
  '芯片-软件研发': ['是否量产', '是否流片'],
  '芯片-产品': ['是否量产', '是否流片'],
  '芯片-销售': ['是否量产', '是否流片'],
  '芯片-算法': ['是否量产', '是否流片'],
  '芯片-芯片设计其他技术类': [`是否量产`, '是否流片'],
  '芯片-其他半导体设计': ['是否量产', '是否流片'],
  '芯片-数模混合芯片': ['是否量产', '是否流片'],
  '芯片-硬件': ['是否量产', '是否流片'],
  '芯片-器件': ['是否量产', '是否流片'],
  '芯片-光学': ['是否量产', '是否流片'],
  '芯片-验证': ['是否量产', '是否流片'],
  '芯片-质量': ['是否量产', '是否流片'],
  '芯片-机器人': ['是否量产', '是否流片'],
  '芯片-结构力学': ['是否量产', '是否流片'],
  '芯片-工艺': ['是否量产', '是否流片'],
  '芯片-IC': ['是否量产', '是否流片'],
  '芯片-Chiplet': ['是否量产', '是否流片'],
  '芯片-FAE': ['是否量产', '是否流片'],
  '芯片-AE': ['是否量产', '是否流片'],
  '工业-建筑设计': ['业务方向'],
  '工业-土建/结构设计': ['业务方向'],
  '工业-电气设计': ['业务方向'],
  '工业-总图设计': ['业务方向'],
  '工业-仪表控制设计': ['业务方向'],
  '工业-暖通设计': ['业务方向'],
  '工业-机械设计': ['业务方向'],
  '工业-设备设计': ['业务方向'],
  '工业-管道设计': ['业务方向'],
  '工业-工艺设计': ['业务方向'],
  '工业-给排水设计': ['业务方向'],
  '工业-工程软件': ['业务方向'],
  '工业-采购': ['业务方向'],
  '工业-施工现场': ['业务方向'],
  '工业-施工完工': ['业务方向'],
  '工业-HSE': ['业务方向'],
  '工业-项目管理': ['业务方向'],
  '工业-项目控制': ['业务方向'],
  '工业-项目服务': ['业务方向'],
  'FIN-财务': ['公司类型', '金融业务方向', '上市经验', '业务类型', '会计准则及证书', '项目及其他技能'],
  'CFO-财务总监': ['公司类型', '上市经验', '业务类型', '会计准则及证书', '项目及其他技能'],
  '医药-医学事务MED': ['治疗领域', '实体瘤'],
  '医药-注册申报RA': ['技术方向'],
  '医药-上市前医学': ['技术方向', '治疗领域', '实体瘤'],
  '医药-生物统计': ['医药程序员'],
  '医药-PV': ['治疗领域'],
  董事会高管: ['公司类型'],
  'CEO-首席执行官': ['公司类型'],
  'COO-首席运营官': ['公司类型'],
  'CTO-首席技术官': ['公司类型'],
  'CHO-首席人力官': ['公司类型'],
  'CSO-首席策略官': ['公司类型'],
  'CSO-首席科学官': ['公司类型'],
  'CIO-首席信息官': ['公司类型'],
  'CIO-首席投资官': ['公司类型'],
  'CMO-首席市场官': ['公司类型'],
  'Sales VP-高级副总裁': ['公司类型'],
  '医药-Biology': ['治疗领域', '技术赛道'],
  'HR-人力': ['HR背景'],
}

const relatedCates = Object.keys(cateMap)
const relatedLabels = []
for (const relatedCate of relatedCates) {
  if (cateMap[relatedCate] && cateMap[relatedCate].length > 0) {
    for (const label of cateMap[relatedCate]) {
      if (!relatedLabels.includes(label)) {
        relatedLabels.push(label)
      }
    }
  }
}

const getDisplayLabels = cates => {
  const displayLabels = []
  if (!cates && cates.length === 0) {
    return displayLabels
  }
  for (const cate of cates) {
    if (cateMap[cate]) {
      displayLabels.push(...cateMap[cate])
    }
  }
  return Array.from(new Set(displayLabels))
}

export { cateMap, relatedCates, relatedLabels, getDisplayLabels }
